import {Parameter, PortfolioAdd} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PATH_SEPARATOR} from "../helper/FileHelper";

export enum PortalPortfolioAddMode {
	FILES = "files",
	FOLDER = "folder"
}

export class PortalPortfolioAdd extends PortfolioAdd implements Parameter {
	public fileName?: string;
	public path?: string;
	public mode?: PortalPortfolioAddMode;
	public initialFile?: boolean;

	constructor(data: any) {
		super(data);

		this.fileName = FunctionHelper.exists(data.fileName) ? data.fileName : "";
		this.path = FunctionHelper.exists(data?.path) ? data.path : PATH_SEPARATOR;
		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : PortalPortfolioAddMode.FILES;
		this.initialFile = FunctionHelper.exists(data?.initialFile) ? data.initialFile : false;
	}

	public static getFileNameDefault(): string {
		return "";
	}

	public static getPathDefault(): string {
		return PATH_SEPARATOR;
	}

	public static getModeDefault(): PortalPortfolioAddMode {
		return PortalPortfolioAddMode.FILES;
	}

	public static getInitialFileDefault(): boolean {
		return false;
	}

	public static fromJson(data: any): PortalPortfolioAdd {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPortfolioAdd(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'fileName': this.fileName,
			'path': this.path,
			'mode': this.mode,
			'initialFile': this.initialFile
		};
	}

	public clone(): PortalPortfolioAdd {
		return PortalPortfolioAdd.fromJson(this.toJson());
	}
}